import { render, staticRenderFns } from "./top-bar.vue?vue&type=template&id=1a4b33c4&scoped=true&"
import script from "./top-bar.vue?vue&type=script&lang=js&"
export * from "./top-bar.vue?vue&type=script&lang=js&"
import style0 from "./top-bar.vue?vue&type=style&index=0&id=1a4b33c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4b33c4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VSpacer,VToolbar,VToolbarItems,VToolbarTitle})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a4b33c4')) {
      api.createRecord('1a4b33c4', component.options)
    } else {
      api.reload('1a4b33c4', component.options)
    }
    module.hot.accept("./top-bar.vue?vue&type=template&id=1a4b33c4&scoped=true&", function () {
      api.rerender('1a4b33c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Settings/components/top-bar.vue"
export default component.exports